import { useAnalytics, getDatabaseContainerType } from '@databases/analytics';
import { useDatabaseStreamState } from '@databases/database-ai-first-creation-ui';
import { messages } from '@databases/intl/messages';
import { useIsFeatureEnabled } from '@databases/utils/hooks/useIsFeatureEnabled';
import React, { type FunctionComponent, useEffect } from 'react';
import { useIntl } from 'react-intl-next';

import emptyIllustration from '../../../../assets/database_empty.svg';
import CompactEmptyState from '../../CompactEmptyState';

export interface EmptyStateProps {
  contentId: string;
}

export const EmptyState: FunctionComponent<EmptyStateProps> = ({ contentId }) => {
  const { formatMessage } = useIntl();
  const analyticsClient = useAnalytics();
  const isDbAiFirstCreationEnabled = useIsFeatureEnabled('dbAiFirstCreation');
  const { isStreaming } = useDatabaseStreamState();

  useEffect(() => {
    if (analyticsClient) {
      analyticsClient.sendTableEmptyStateScreenEvent({
        contentId,
        databaseContainer: getDatabaseContainerType(),
      });
    }
  }, [analyticsClient, contentId]);

  if (isDbAiFirstCreationEnabled && isStreaming) {
    return null;
  }

  return (
    <CompactEmptyState
      heading={formatMessage(messages['table-layout.empty-database-empty-state-heading'])}
      description={formatMessage(
        messages['table-layout.empty-database-empty-state-description']
      )}
      imageUrl={emptyIllustration}
    />
  );
};
